var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 643,
    viewBox: "0 0 643 643",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M487.339 1.60678C499.402 -3.27267 512.839 4.48504 514.645 17.3719L548.32 257.672C548.547 259.292 548.972 260.879 549.586 262.396L640.573 487.339C645.452 499.402 637.694 512.839 624.807 514.645L384.507 548.32C382.887 548.547 381.3 548.972 379.783 549.586L154.84 640.573C142.777 645.452 129.34 637.694 127.534 624.807L93.8594 384.507C93.6324 382.887 93.2073 381.3 92.5937 379.783L1.60678 154.84C-3.27267 142.777 4.48504 129.34 17.3719 127.534L257.672 93.8594C259.292 93.6324 260.879 93.2073 262.396 92.5937L487.339 1.60678Z",
    fill: "#43FEAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.1af01bef8036f94bb7c4312285cc85c5.svg";
export { ForwardRef as ReactComponent };